var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"proceed-btn",class:{ disabled: !_vm.isProceedEnable || _vm.isLoading, loading: _vm.isLoading }},[_vm._v(" "+_vm._s(_vm.isLoading ? '' : 'Proceed')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }